import React, { useState, useContext } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { AppContext } from "../../../context/Context";

const DonutChartNegative = ({ data, colors }) => {
  const { dataRange, clearState } = useContext(AppContext);

  const [activeIndex, setActiveIndex] = useState(null);

  // const colors = ["#CCFF33", "#70E000", "#52B69A"];
  const formatNumber = (number) => {
    return new Intl.NumberFormat().format(number);
  };
  const onPieEnter = (_, index) => setActiveIndex(index);
  const onPieLeave = () => setActiveIndex(null);

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    if (percent === undefined) return null; // Prevent errors
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
    const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontWeight: "normal", fontSize: "10px", color: "grey" }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      style={{ marginTop: "-10px" }}
    >
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius="70%"
          innerRadius="60%"
          dataKey="value"
          startAngle={-270}
          endAngle={360}
          onMouseEnter={onPieEnter}
          onMouseLeave={onPieLeave}
          isAnimationActive={
            dataRange === "All" && clearState !== null ? true : false
          }
          animateNewValues={
            dataRange === "All" && clearState !== null ? true : false
          }
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[index % colors.length]}
              stroke={activeIndex === index ? "pink" : "none"}
              strokeWidth={activeIndex === index ? 2 : 0}
              style={{ cursor: "pointer" }}
            />
          ))}
        </Pie>
        <Tooltip formatter={(value) => `($${formatNumber(value)})`} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DonutChartNegative;
